import { lazy } from 'react'

export const StolenPhoneVariant1 = lazy(() => import('./StolenPhoneVariant1'))
